import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams } from '../types';
import META from './useTrackCreditWarningPopoverDismissed.meta';

export type UseTrackCreditWarningPopoverDismissedParams = CreditAnalyticsParams & {
  type: 'popover' | 'banner';
};

export const useTrackCreditWarningPopoverDismissed = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditWarningPopoverDismissed = useCallback(
    (params: UseTrackCreditWarningPopoverDismissedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditWarningPopoverDismissed };
};
